// src/components/ui/Button.jsx
import { C } from '../../styles/tokens';

const variants = {
  primary: {
    background: `linear-gradient(135deg, ${C.magenta}, ${C.violet})`,
    border: 'none', color: '#fff',
  },
  outline: {
    background: 'transparent',
    border: `1px solid rgba(254,52,232,0.35)`, color: '#fff',
  },
  ghost: {
    background: 'rgba(255,255,255,0.05)',
    border: '1px solid rgba(255,255,255,0.1)', color: '#fff',
  },
  danger: {
    background: `linear-gradient(135deg, ${C.danger}, #c0392b)`,
    border: 'none', color: '#fff',
  },
  success: {
    background: `linear-gradient(135deg, ${C.success}, #00a86b)`,
    border: 'none', color: '#fff',
  },
};

const sizes = {
  sm: { padding: '7px 14px',  fontSize: '12px' },
  md: { padding: '11px 22px', fontSize: '14px' },
  lg: { padding: '14px 30px', fontSize: '15px' },
};

export default function Button({
  children,
  variant = 'primary',
  size    = 'md',
  fullWidth = false,
  disabled  = false,
  loading   = false,
  icon,
  onClick,
  style = {},
  ...props
}) {
  const v = variants[variant] || variants.primary;
  const s = sizes[size]       || sizes.md;

  return (
    <button
      onClick={onClick}
      disabled={disabled || loading}
      style={{
        display:        'inline-flex',
        alignItems:     'center',
        justifyContent: 'center',
        gap:            '8px',
        borderRadius:   '9px',
        fontFamily:     "'Syne', sans-serif",
        fontWeight:     700,
        cursor:         disabled || loading ? 'not-allowed' : 'pointer',
        opacity:        disabled ? 0.5 : 1,
        transition:     'all 0.25s cubic-bezier(0.16,1,0.3,1)',
        width:          fullWidth ? '100%' : 'auto',
        position:       'relative',
        overflow:       'hidden',
        ...v,
        ...s,
        ...style,
      }}
      onMouseEnter={e => { if (!disabled) e.currentTarget.style.transform = 'translateY(-2px)'; }}
      onMouseLeave={e => { e.currentTarget.style.transform = 'translateY(0)'; }}
      {...props}
    >
      {loading ? (
        <span style={{ width: 14, height: 14, border: '2px solid rgba(255,255,255,0.3)', borderTopColor: '#fff', borderRadius: '50%', animation: 'spin 0.6s linear infinite', display: 'inline-block' }} />
      ) : icon ? (
        <span style={{ fontSize: '1.1em' }}>{icon}</span>
      ) : null}
      {children}
    </button>
  );
}
